/* eslint-disable no-undef */
jQuery(function ($) {
  $('#show-all-news').on('click', loadMoreNews)
  function loadMoreNews () {
    $.ajax({
      data: {
        _ajax_nonce: myVariables.load_more_posts_nonce,
        action: 'load_more_posts',
        attributes: myVariables.attributes
      },
      type: 'POST',
      dataType: 'json',
      url: myVariables.ajax_url,
      /* execute before data fetch */
      beforeSend: function () {
        $('#show-all-news').html('Ladataan...')
        // prevent click event
        $('#show-all-news').off('click')
      },
      /* data fetch succeeded */
      success: function (data) {
        $('#uutisia').append(data.posts_html)
      },
      /* data fetch failed */
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error when fetching posts')
        /* console.log('jqXHR: ', jqXHR)
          console.log('textStatus: ', textStatus)
          console.log('errorThrown: ', errorThrown) */
      },
      /* execute after every data fetch */
      complete: function (jqXHR) {
        // remove loading button
        $('#show-all-news').remove()
      }
    })
  }
})
